<template>
  <div
    v-if="sortKey"
    class="pos-id-sort-head"
    :class="{ 'is-active': active }"
    :title="title"
    @click="handleClick"
  >
    <span class="pos-id-sort-head__label">{{ label }}</span>
    <i class="pos-id-sort-head__icon" :class="iconClass" aria-hidden="true"></i>
  </div>
  <span v-else class="pos-id-sort-head__plain">{{ label }}</span>
</template>

<script>
/**
 * pos-id 列表表頭：可排序欄位顯示 ⇅ 標誌（當前排序欄位顯示 ↑ / ↓ 並高亮）。
 * 是否高亮整列表頭由各頁面 fields 的 variant='info' 決定（見 pos-id.scss）。
 */
export default {
  name: 'PosIdSortableHeader',
  props: {
    label: {
      type: String,
      default: ''
    },
    sortKey: {
      type: String,
      default: ''
    },
    activeSortKey: {
      type: String,
      default: ''
    },
    direct: {
      type: String,
      default: 'desc'
    }
  },
  computed: {
    active() {
      return this.sortKey !== '' && this.sortKey === this.activeSortKey
    },
    ascending() {
      return this.direct === 'asc'
    },
    iconClass() {
      if (!this.active) {
        return 'el-icon-sort'
      }
      return this.ascending ? 'el-icon-top' : 'el-icon-bottom'
    },
    title() {
      if (this.active) {
        return `目前按「${this.label}」${this.ascending ? '升序' : '降序'}排列，點擊切換排序方向`
      }
      return `點擊按「${this.label}」排序`
    }
  },
  methods: {
    handleClick() {
      if (!this.sortKey) {
        return
      }
      this.$emit('sort', this.sortKey)
    }
  }
}
</script>

<style lang="scss" scoped>
.pos-id-sort-head {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  color: #3f4a5a;

  &:hover {
    color: #0e72bc;
  }

  &__label {
    line-height: 1.4;
  }

  &__icon {
    margin-left: 4px;
    color: #98a2b3;
    font-size: 12px;
  }

  &.is-active {
    color: #0b5c96;
    font-weight: 600;

    .pos-id-sort-head__icon {
      color: #0e72bc;
    }
  }

  &__plain {
    white-space: nowrap;
  }
}
</style>
